angular.module('app.api').factory('EmailApi', [
  'api',
  function EmailApi(api) {
    const emailApi = {
      getAllEmails: function() {
        return api.get('emails')
      },
      updateEmailById: function(emailId, payload) {
        return api.put(`emails/${emailId}`, payload)
      },
    }
    return emailApi
  },
])



// WEBPACK FOOTER //
// ./scripts/admin-panel/email-listing/email-listing.api.js